import { Nullable } from '@starsoft/common/interfaces';
import {
  UseKycMeByOriginIdPrefetchProps,
  UseKycMeQueryKeyProps,
} from './props';
import { Kyc } from '@starsoft/common/models';
import { KYCQueryKeys } from '../../queryKeys';
import { fetchKycMeByOriginId } from './service';

export async function prefetchKycMeByOriginId({
  queryClient,
  originId,
  instance,
}: UseKycMeByOriginIdPrefetchProps): Promise<Nullable<Kyc>> {
  const queryKey: UseKycMeQueryKeyProps = [
    KYCQueryKeys.Me,
    originId?.toString(),
  ];

  await queryClient.prefetchQuery({
    queryKey: queryKey,
    queryFn: queryContext => fetchKycMeByOriginId(queryContext, instance),
  });
  const { data: kyc } = queryClient.getQueryState<Nullable<Kyc>>(queryKey);

  return kyc;
}
